// Single source for the public-artifact links the docs surface.

export const REPO_URL = 'https://github.com/galentidesign/portfolio'

/** Prefix for linking a path within the repo, e.g. a component directory. */
export const REPO_TREE_URL = `${REPO_URL}/tree/main`

/**
 * The public Figma library (§5.3 twin artifact). Component-level node links
 * live in each manifest's links.figma and land as M7 ports complete.
 */
export const FIGMA_LIBRARY_URL = 'https://www.figma.com/design/FDrHYp9F366R2GZ0Ra9koO/portfolio'
